<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="unnumbered-1">
<div class="heading heading-with-title heading-without-image" id="unnumbered-1-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Fatal Insomnia Medical Thrillers</h1>
</div>
<h2 class="subtitle">What Keeps You Awake at Night?</h2>
</div>
</div>
</div>
<div class="text" id="unnumbered-1-text">
<div class="inline-image inline-image-kind-photograph inline-image-size-large inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-begins-section inline-image-before-element-end">
<div class="inline-image-container">
<a class="link-contains-image" href="https://cjlyons.net/fatalinsomnia/" target="_blank">
<img alt="Fatal Insomnia Medical Thrillers" src="images/fatalinsomnia3book.jpg"/>
</a>
</div>
</div>
<p class="first first-in-chapter first-full-width"><a class="content-external-link" href="https://cjlyons.net/fatalinsomnia/" target="_blank">FAREWELL TO DREAMS, Fatal Insomnia Book #1</a></p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/fatalinsomnia/" target="_blank">A RAGING DAWN, Fatal Insomnia Book #2</a></p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/fatalinsomnia/" target="_blank">THE SLEEPLESS STARS, Fatal Insomnia Book #3</a></p>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center">Based on a real-life disease that promises a horrifying death, CJ’s Fatal Insomnia series chronicles one doctor’s search for redemption, hope, and an unexpected chance at love.</p>
<p class="alignment-block-content alignment-block-content-center"><i>She might be dying, but she’s finally learning how to live…</i></p>
</div>
</div>
<div class="blockquote-container prose without-attribution">
<blockquote class="prose without-attribution">
<div class="blockquote-image-block blockquote-image-aspect-wide">
<div class="blockquote-image-size-container">
<img alt="" class="blockquote-image-image" src="images/blockquote-big-66-screen.png"/>
</div>
</div>
<p class="first blockquote-content blockquote-content-prose blockquote-position-first blockquote-position-last">CJ Lyons scores a major triumph. Totally absorbing and impossible to put down.” <i>~Douglas Preston</i></p>
</blockquote>
</div>
<p class="subsq">Want to be the first to have a chance to read the new books? Sign up for my <a class="content-external-link" href="http://cjlyons.net/signup" target="_blank">Thrillers with Heart newsletter HERE</a>—and you’ll also get a free copy of the first Lucy adventure, SNAKE SKIN!</p>
<div class="inline-image inline-image-kind-photograph inline-image-size-full inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end">
<div class="inline-image-container">
<a class="link-contains-image" href="http://cjlyons.net/signup" target="_blank">
<img alt="email signup" src="images/newmailsignupvellum.jpg"/>
</a>
</div>
</div>
<p class="subsq"><i>(Already read SNAKE SKIN? Feel free to share this offer with your thriller-loving friends!)</i></p>
<p class="subsq">Be sure to open the Thrillers with Heart emails; they’ll arrive every few weeks with info on contests, new books, and exclusive offers for my readers!</p>
<div class="inline-image inline-image-kind-freestanding inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-after-section-begin">
<div class="inline-image-container">
<a class="link-contains-image" href="http://cjlyons.net/signup" target="_blank">
<img alt="Thanks for reading! CJ" src="images/image-300thanks-448.jpg"/>
</a>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fatal-insomnia-medical-thrillers.vue?0cb94493